export const tasksMutationKeys = {
  ADD_ASSIGNEE_SUGGESTION_MUTATION: 'addAssigneeSuggestionMutation',
  ADD_TITLE_SUGGESTION_MUTATION: 'addTitleSuggestionMutation',
  CREATE_TASK_MUTATION: 'createTaskMutation',
  UPDATE_TASK_DETAIL_MUTATION: 'updateTaskDetailMutation',
  UPDATE_TASK_MUTATION: 'updateTaskMutation',
  UPDATE_MEDIA_MUTATION: 'updateMediaMutation',
  UPDATE_COMMENT_MUTATION: 'updateCommentMutation',
  COPY_TASK_MUTATION: 'copyTaskMutation'
}

export const tasksQueriesKeys = {
  GET_COMMENTS_AND_MEDIA: 'get_comments_and_media',
  GET_PROJECT_USERS: 'get_project_users',
  GET_TASK: 'get_task',
  GET_TASK_TITLE_SUGGESTION: 'get_task_title_suggestion',
  GET_PROJECT_MEMBERS: 'get_teams_members',
  GET_PROJECT_TEAMS: 'get_teams_teams',
  GET_PROJECT_CONTACTS: 'get_teams_contacts',
  GET_RECENT_ASSIGNED: 'get_recent_assigned',
  GET_TASK_LIST: 'get_task_list'
}
